import { type RouteObject } from 'react-router-dom'
import { STORAGE_URL } from './Storage.navigator'
import { StoragePage } from './Storage.page'
import { STORAGE_CONTAINER_DETAIL_URL } from './container-detail/ContainerDetail.navigator'
import { StorageContainerDetailPage } from './container-detail/ContainerDetail.page'
import { STORAGE_SCAN_DESTINATION_URL } from './scan-destination/StorageScanDestination.navigator'
import { StorageScanDestinationPage } from './scan-destination/StorageScanDestination.page'
import { STORAGE_MOVE_OPTIONS_URL } from './move-options/MoveOptions.navigator'
import { MoveOptionsPage } from './move-options/MoveOptions.page'

export const storageRoutes: RouteObject[] = [
  {
    id: '(Storage) Storage list',
    path: STORAGE_URL,
    element: <StoragePage />
  },
  {
    id: '(Storage) Storage move options',
    path: STORAGE_MOVE_OPTIONS_URL,
    element: <MoveOptionsPage />
  },
  {
    id: '(Storage) Container detail',
    path: STORAGE_CONTAINER_DETAIL_URL,
    element: <StorageContainerDetailPage />
  },
  {
    id: '(Storage) Scan destination',
    path: STORAGE_SCAN_DESTINATION_URL,
    element: <StorageScanDestinationPage />
  }
]
